"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/journeySection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type JourneySection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "journey-item-nine one wow fadeInUp" | "journey-item-nine two wow fadeInUp" | "journey-item-nine three wow fadeInUp" */
    className: string;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "Our Commitment to Excellence" | "Tailored Home Care Plans for all Services" | "Program to Maintain Independence" */
    h40Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/about/commit-bg-1.png" | "/Templates/Doccure/img/about/commit-bg-2.png" | "/Templates/Doccure/img/about/commit-bg-3.png" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/about/commit-img-1.png" | "/Templates/Doccure/img/about/commit-img-2.png" | "/Templates/Doccure/img/about/commit-img-3.png" */
    imageWithBasePath1Src: string;
    /** Detected variants: "col-lg-4 col-md-6" */
    divClassName?: string;
    /** Detected variants: "journey-title mb-0" */
    h40ClassName?: string;
    /** Detected variants: "commit-bg" */
    alt?: string;
    /** Detected variants: "img-fluid bg-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "commit-bg" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "journey-btn" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
};
export type HomeNineJourneySectionGeneratedProps = {
    divDiv0H40H4Props?: Partial<ComponentProps<"h4">> | ((item: JourneySection46sItem) => Partial<ComponentProps<"h4">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: JourneySection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: JourneySection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: JourneySection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    journeySection46s: JourneySection46sItem[];
    journeySection46sItemWrapper?: (item: JourneySection46sItem, content: ReactNode) => ReactNode;
    journeySection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    journeySection46sLinkVisible?: boolean;
    journeySection46sLinkRenderer?: (item: JourneySection46sItem, defaultNode: ReactNode) => ReactNode;
    journeySection46sImageVisible?: boolean;
    journeySection46sImageRenderer?: (item: JourneySection46sItem, defaultNode: ReactNode) => ReactNode;
    journeySection46sH4Visible?: boolean;
    journeySection46sH4Renderer?: (item: JourneySection46sItem, defaultNode: ReactNode) => ReactNode;
    journeySection46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: JourneySection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    journeySection46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: JourneySection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    journeySection46sH4Props?: Partial<ComponentProps<"h4">> | ((item: JourneySection46sItem) => Partial<ComponentProps<"h4">>);
};

const HomeNineJourneySectionGenerated: FC<HomeNineJourneySectionGeneratedProps> = ({
    divDiv0H40H4Props,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath1ImageProps,
    divDiv0Link0LinkProps,
    sectionDiv0Div0ClassName,
    journeySection46s,
    journeySection46sItemWrapper,
    journeySection46sRenderer,
    journeySection46sLinkVisible,
    journeySection46sLinkRenderer,
    journeySection46sImageVisible,
    journeySection46sImageRenderer,
    journeySection46sH4Visible,
    journeySection46sH4Renderer,
    journeySection46sLinkProps,
    journeySection46sImageProps,
    journeySection46sH4Props,
}) => {
    return (
        <section className="journey-section-nine section pt-0">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row g-3 justify-content-center"}>
                    {renderCollectionNode(
                        journeySection46s,
                        (item: JourneySection46sItem) => (
                            <div className={item.divClassName ?? "col-lg-4 col-md-6"} key={item.key}>
                                <div className={item.className} data-wow-duration={item.dataWowDuration}>
                                    {renderItemNode(journeySection46sH4Visible, journeySection46sH4Renderer, item, (
                                        <h4 className={item.h40ClassName ?? "journey-title mb-0"} {...(typeof journeySection46sH4Props === "function" ? journeySection46sH4Props(item) : (journeySection46sH4Props ?? {}))} {...(typeof divDiv0H40H4Props === "function" ? divDiv0H40H4Props(item) : (divDiv0H40H4Props ?? {}))}>{item.h40Text}</h4>
                                    ))}
                                    {renderItemNode(journeySection46sLinkVisible, journeySection46sLinkRenderer, item, (
                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "journey-btn"} {...(typeof journeySection46sLinkProps === "function" ? journeySection46sLinkProps(item) : (journeySection46sLinkProps ?? {}))} {...(typeof divDiv0Link0LinkProps === "function" ? divDiv0Link0LinkProps(item) : (divDiv0Link0LinkProps ?? {}))}>
                                            {" "}
                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                            {" "}
                                        </SmartLink>
                                    ))}
                                    {renderItemNode(journeySection46sImageVisible, journeySection46sImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt ?? "commit-bg"} className={item.imageWithBasePath0ClassName ?? "img-fluid bg-one"} {...(typeof journeySection46sImageProps === "function" ? journeySection46sImageProps(item) : (journeySection46sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                    {renderItemNode(journeySection46sImageVisible, journeySection46sImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath1Src} alt={item.imageWithBasePath1Alt ?? "commit-bg"} className={item.imageWithBasePath1ClassName ?? "img-fluid img-one"} {...(typeof journeySection46sImageProps === "function" ? journeySection46sImageProps(item) : (journeySection46sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath1ImageProps === "function" ? divDiv0ImageWithBasePath1ImageProps(item) : (divDiv0ImageWithBasePath1ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        journeySection46sItemWrapper,
                        journeySection46sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeNineJourneySectionGenerated;
